import React from "react";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

import './styles.css';

const Negligencia = () => {
  return (
    <>
      <Card className="text-center">
        <Card.Header><div className="opcoes">Atenção aos Detalhes </div></Card.Header>
        <Card.Body>
          {/* <Card.Title> Crucial para garantir 
            o desempenho ótimo das redes Wi-Fi. </Card.Title> */}
          <Card.Text>
            <div className="opcoes">
              <strong>Negligência: </strong>
              Às vezes, detalhes críticos podem ser negligenciados, o que pode 
              deixar a rede vulnerável, exemplo: nenhuma configuração de segurança e senha padrão nos equipamentos.
            </div>
            <div className="opcoes">
              <strong>Atualização dos equipamentos: </strong>
              Firmware desatualizado é um problema frequentemente negligenciado, mas crucial para a segurança e desempenho dos dispositivos.
            </div>
            <div className="opcoes">
              <strong>Riscos de Compartilhar a Senha: </strong>
              Não temos o hábito de configurar a rede para visitantes, na maioria das vezes deixamos nosso 
              cliente compartilhar a senha, esse prática pode expor a rede a vários riscos de segurança. 
            </div>
          </Card.Text>
          {/* <Button variant="primary">Go somewhere</Button> */}
        </Card.Body>
        {/* <Card.Footer className="text-muted">Configurações de 
          segurança robustas, como WPA3, são essenciais para proteger a rede contra acessos não autorizados.</Card.Footer> */}
      </Card>
    </>
  )
}
export default Negligencia;